import '../scss/main.scss';

(() => {
  document.querySelectorAll('button[data-open-filters]').forEach(el => {
    el.addEventListener('click', event => {
      const sidebar = event.currentTarget.parentElement.parentElement;
      sidebar.classList.toggle('filters--open');
      if (sidebar.classList.contains('filters--open')) {
        event.currentTarget.innerText = 'Close Filters';
      } else {
        event.currentTarget.innerText = 'Open Filters';
      }
    });
  });
})();
